import { useState } from "react";
import { categoryLabel, type CategoryData } from "../../../lib/categories";
import { UNITS, inUnit, roundTo, unitById } from "../../../lib/units";

export function Legend({
  categories,
  total,
  worn,
  consumable,
  unitId,
  selectedIndex,
  onSelect,
  onDeselect,
  onUnitChange,
}: {
  categories: CategoryData[];
  total: number;
  worn: number;
  consumable: number;
  unitId: number;
  selectedIndex: number | null;
  onSelect: (i: number) => void;
  onDeselect: () => void;
  onUnitChange: (unitId: number) => void;
}) {
  const [orderBy, setOrderBy] = useState<"category" | "weight">("category");
  const unit = unitById(unitId);
  const sorted = [...categories].sort((a, b) =>
    orderBy === "weight" ? b.grams - a.grams : a.name.toLowerCase().localeCompare(b.name.toLowerCase()),
  );
  const maxRows = 12;
  const columns: CategoryData[][] = [];
  sorted.forEach((c, i) => {
    if (i % maxRows === 0) columns.push([]);
    columns[columns.length - 1].push(c);
  });
  return (
    <div className="Legend">
      <div>
        <div className="colors">
          <div className="headingHolder">
            <span className="leftHeading" onClick={() => setOrderBy("category")}>
              Category
            </span>
            <span className="middleHeading" onClick={() => setOrderBy("weight")}>
              Weight
            </span>
            <span className="rightHeading" style={{ width: categories.length >= 18 ? 45 : 60 }} onClick={() => setOrderBy("weight")}>
              %
            </span>
          </div>
          <div className="colorsHolder">
            {columns.map((col, ci) => (
              <ul key={ci}>
                {col.map((c) => {
                  let pct = total > 0 ? (c.grams / total) * 100 : 0;
                  pct = pct < 1 ? roundTo(pct, 2) : Math.round(pct);
                  return (
                    <li
                      key={c.index}
                      id={`legendCat${c.index}`}
                      title={c.name}
                      style={{ fontWeight: selectedIndex === c.index ? "bold" : "normal" }}
                      onMouseEnter={() => onSelect(c.index)}
                      onMouseLeave={onDeselect}
                      onClick={() => onSelect(c.index)}
                    >
                      <span className="swatchHolder">
                        <span className={`colorSwatch ${c.cssClass}d`} />
                      </span>
                      <span className="label">{categoryLabel(c.name)}</span>
                      <span className="gramWeightCol">
                        {inUnit(c.grams, unit)}
                        {unit.abbreviation}
                      </span>
                      <span className="percent">{pct}%</span>
                    </li>
                  );
                })}
              </ul>
            ))}
          </div>
        </div>
        <div className="totals">
          <hr />
          <div className="total1">
            <span className="totalDisplay">Total</span>
            <span>{inUnit(total, unit)}</span>
            <div className="select-style">
              <select aria-label="Unit" value={unitId} onChange={(e) => onUnitChange(Number(e.target.value))}>
                {UNITS.map((u) => (
                  <option key={u.id} value={u.id}>
                    {u.abbreviation}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="total2">
            <span>Worn</span>
            <span>{inUnit(worn, unit)}</span>
            <span>{unit.abbreviation}</span>
          </div>
          <div className="total2">
            <span>Consumable</span>
            <span>{inUnit(consumable, unit)}</span>
            <span>{unit.abbreviation}</span>
          </div>
          <div className="total2">
            <span>Pack Weight</span>
            <span>{inUnit(total - worn, unit)}</span>
            <span>{unit.abbreviation}</span>
          </div>
        </div>
      </div>
    </div>
  );
}
